export function skipTransition(element: HTMLElement, disableDuration = 0) {
  const original = element.style.transition;
  element.style.transition = 'none';
  window.setTimeout(() => {
    element.style.transition = original;
  }, disableDuration);
}
